define(function (require) {
	const Radio = require('backbone.radio');
	const PasswordValidator = require('civicsUtils/password_validator');
	const LoginPasswordResetModel = require('civicsModels/login_passwordReset_model');
	const tpl = require('./templates/t_itv_login_passwordReset.hbs');
	const ViewManager = require('civicsUtils/view_manager');

	return Marionette.ItemView.extend({
		template: tpl,
		tagName: 'div',
		className: 'password-reset-holder',
		initialize: function (options) {
			this.config = options.config;
			this.modalContainer = options.modalContainer;
			this.passwordValidator = new PasswordValidator(this.config.globalConfig.get('login').get('passwordCriterias'), 'accountPasswordCriteria');

			if (__DEV__) console.log('itvPasswordReset initialized');
			// Added the old password to the body tag so checking there first to fill in the old password, otherwise do the loginChannel request
			this.oldPassword = $('body.rhy-body').data("password") ? $('body.rhy-body').data("password") : this.config.loginChannel.request('signin:password');

			this.model = new LoginPasswordResetModel();
		},
		ui: {
			inpConfirmCode: '.confirmPassword .input-text',
			inpNewCode: '.newPassword .input-text',
			btnSubmit: '.login-submit',
			closeModalButton: '.bbm-btn-close',
			criteriaList: '.field-requirements-list'
		},
		events: {
			'click @ui.btnSubmit': 'submitClicked',
			'keyup @ui.inpNewCode': 'passwordFeedback',
			'click @ui.closeModalButton':'closeModal'
		},
		modelEvents: {
			change: 'render',
		},
		onRender: function() {
		  this.$el.rhythmThemeInitCivics();
		  ViewManager.resetErrorMessages(this);
		  this.ui.criteriaList.removeClass('helper-msg');
		},
        onShow: function(){
            this.passwordFeedback();
        },
		closeModal:function(){
			this.modalContainer.hideModal();
		},
		passwordFeedback: function (e) {
			//Don't reset error message when Enter Key is pressed
			if (e && !(e.which === 13)) {
				ViewManager.resetErrorMessages(this);
			}
			var newPassword = this.ui.inpNewCode.val();
			this.passwordValidator.validate(newPassword, this, false);
		},
		submitClicked: function (e) {
			e.preventDefault();
			const self = this;

			// hide all error messages
			ViewManager.resetErrorMessages(this);

			const selector = "[name='password']";
			this.$el.find(selector).parent().removeClass('error');

			if (__DEV__) console.log('itvPasswordReset-submitClicked e', e, 'this', this);
			const newPassword = this.ui.inpNewCode.val();
			const confirmPassword = this.ui.inpConfirmCode.val();
			if (newPassword !== confirmPassword) {
				this.showPasswordError(this.config.PasswordResetDifferentError, true);
			}
			else if (newPassword === this.oldPassword) {
				this.showPasswordError(this.config.PasswordResetNochangeError, false);
			}
			else if (!this.passwordValidator.validate(newPassword, this)) {
				this.showPasswordError(this.config.PasswordResetVerificationError, false);
			}
			else {
				this.ui.btnSubmit.attr('disabled','disabled');
				this.model.set('NewPassword', newPassword);
				this.model.set('OldPassword', this.oldPassword);
				this.model.save(null, {
					type: 'put',
					success: _.bind(function (model, response) {
						if (__DEV__) console.log('submitClicked success', model, response);
						if (response !== undefined) {
							this.config.loginChannel.command('go:checkQuestion');
						}
						else {
							self.ui.btnSubmit.removeAttr('disabled');
							self.showPasswordError(this.config.PasswordResetError, false);
						}
					}, this),
					error: _.bind(function (model, response) {

						var msg = this.config.PasswordResetError;
						if(response.responseJSON.responseStatus.message != undefined) {
							if(response.responseJSON.responseStatus.message.search('Password is incorrect') !== -1) msg = i18n.t('CIVICS.COMMON.INCORRECT_PW_ERROR');                        
							if(response.responseJSON.responseStatus.message.search('minimum length requirements') !== -1) msg = i18n.t('CIVICS.COMMON.MINIMUM_LENGTH_PW_ERROR');                        
							if(response.responseJSON.responseStatus.message.search('use any of your last') !== -1) {
								var r = /\d+/;
								var i = (response.responseJSON.responseStatus.message.match(r))
								msg = i18n.t('CIVICS.COMMON.REUSE_PW_ERROR', { count: i });        
							}
							if(response.responseJSON.responseStatus.message.search('Banned Word Error') !== -1) msg = i18n.t('CIVICS.COMMON.BANNED_WORDS_PW_ERROR');
							if(response.responseJSON.responseStatus.message.search('cannot be changed until after') !== -1) {
								var r = /\d+/;
								var i = (response.responseJSON.responseStatus.message.match(r))
							   msg = i18n.t('CIVICS.COMMON.MINIMUM_DAYS_PW_ERROR', { days: i });
							}
							if (response.responseJSON.responseStatus.message.search('cannot be the same') !== -1) msg = this.config.PasswordResetNochangeError;
						  }					
						
						  //self.displayError("confirmPassword", msg);
						  self.ui.btnSubmit.removeAttr('disabled');
						  self.showPasswordError(msg);
					}, this),
				});
			}
		},
		showPasswordError: function (errorMessage, confirmError) {
			var error = {};
			error.validationError = {};
			error.validationError.password = errorMessage;
			ViewManager.errorToWindow(error, this);

			if(confirmError) {
				this.ui.inpConfirmCode.parent().addClass('error');
			}

			this.ui.inpNewCode.addClass('error');
		},
		templateHelpers: function () {
			var self = this;
			return {
				passwordCriterias: this.passwordValidator.getCriterias(),
				passwordExpired: this.config.isPasswordExpired != null && this.config.isPasswordExpired,
				instruction: function(){
					if(self.config.isPasswordExpired != null && self.config.isPasswordExpired)
						return i18n.t('CIVICS.LOGIN.PASSWORD_EXPIRED_INSTRUCTION')
					else
						return i18n.t('CIVICS.LOGIN.RESET_PASSWORD_INSTRUCTION')
				}
			};
		},
	});
});
